/* eslint-disable no-underscore-dangle */

import firebaseAuth from './firebase';

export function logout() {
  return firebaseAuth().signOut();
}

export function getMyUid() {
  return firebaseAuth().currentUser.uid;
}

export function getMyEmail() {
  return firebaseAuth().currentUser.email;
}

// get identity provider
export function getMyIdp() {
  const provider = firebaseAuth().currentUser.providerData;
  if (provider && provider.length > 0) {
    return 'firebase';
  }
  return 'FC';
}

export function login(email, pw) {
  return firebaseAuth().signInWithEmailAndPassword(email, pw);
}

export function customLogin(token) {
  return firebaseAuth().signInWithCustomToken(token);
}

export function redirectMtlsBroker(prefix) {
  const tokenBroker = window._env_ ? `https://${prefix}.${window._env_.TOKEN_DOMAIN}` : (`https://${prefix}.${process.env.REACT_APP_TOKEN_DOMAIN}` || 'http://localhost:5000');
  window.location = `${tokenBroker}/redirect?redirect_uri=${encodeURIComponent(window.location.href)}`;
}
